module.exports = __webpack_public_path__ + "img/txt_to-official.7382ca62.png";